var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { useCommentActions } from "../../../hooks/actions/useCommentActions";
import { CommentsApp } from "../../CommentsApp/CommentsApp";
import { PageContentWrap, PageTitle, PageWrap } from "../Page/Page";
function UserCommentsPage() {
    const [userComments, setUserComments] = useState(null);
    const [loading, setLoading] = useState(true);
    const { loadUserComments, addUserComment } = useCommentActions();
    useEffect(() => {
        getUserComments();
    }, []);
    const getUserComments = () => __awaiter(this, void 0, void 0, function* () {
        setLoading(true);
        yield loadUserComments((comments) => {
            setUserComments(comments);
        });
        setLoading(false);
    });
    const onAddUserComment = (comment) => __awaiter(this, void 0, void 0, function* () {
        yield addUserComment(comment, (comments) => {
            setUserComments(comments);
        });
    });
    return (_jsx(PageWrap, { loading: loading, onRefresh: getUserComments, children: _jsxs(PageContentWrap, { children: [_jsx(PageTitle, { description: __("Comments related to your user", "quicktasker"), children: __("User comments", "quicktasker") }), userComments && (_jsx(CommentsApp, { comments: userComments, addComments: onAddUserComment }))] }) }));
}
export { UserCommentsPage };
